/** @type {(import("vuex").Module<>)} */
export const prompt = {
    namespaced: true,
    modules: {},
};
